import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { Row, Col, Form, Input } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { InputDecimal } from '@/components/_common';

const defaultEmptyFieldError = {
  required: true,
  message: <FormattedMessage id="commons.form.errors.requiredField" />,
};

function RatesForm({ form }) {
  const intl = useIntl();

  return (
    <Form form={form} name="documentTypeGeneralInfo">
      <Row gutter={[8, 8]}>
        <Col xs={24} md={12} lg={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'documentTypes.rate.form.numberInstallments',
            })}
            name="numberInstallments"
            rules={[
              defaultEmptyFieldError,
              {
                validator: (_, value) =>
                  value >= 1
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error('A quantidade deve ser igual ou maior que 1'),
                      ),
              },
            ]}
          >
            <InputDecimal fractions={0} min={0} />
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12} lg={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'documentTypes.rate.form.percentRate',
            })}
            name="percentRate"
            rules={[defaultEmptyFieldError]}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

RatesForm.propTypes = {
  form: PropTypes.object.isRequired,
};

export default RatesForm;
